import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { FieldLengths, Patterns } from '../personal-details.expressions';
import { ApInsertionValidator } from '../validators/insertion.validator';

import { PartnerDetails, PartnerDetailsForm, Salutation } from './partner-details.model';

/** The ApPartnerDetailsService is used to create a formGroup. To be used with {@link ApPartnerDetailsComponent} */
@Injectable()
export class ApPartnerDetailsService {
    public constructor() {}

    public createFormGroup(partnerDetails: PartnerDetails): FormGroup<PartnerDetailsForm> {
        const partnerNameUsed = partnerDetails.salutation !== Salutation.birthName;
        return new FormGroup<PartnerDetailsForm>({
            usePartnerName: new FormControl<boolean>(partnerNameUsed),
            salutation: new FormControl<number>(partnerDetails.salutation, {
                validators: Validators.required,
                updateOn: 'change'
            }),
            partnerInsertion: new FormControl<string>(partnerDetails.partnerInsertion, {
                validators: [
                    Validators.maxLength(FieldLengths.INSERTION),
                    Validators.pattern(Patterns.INSERTION),
                    ApInsertionValidator.createValidator()
                ]
            }),
            partnerLastName: new FormControl<string>(partnerDetails.partnerLastName, [
                Validators.maxLength(FieldLengths.LASTNAME),
                Validators.required,
                Validators.pattern(Patterns.LASTNAME)
            ])
        });
    }

    public addToFormGroup(formGroup: FormGroup, partnerDetails: PartnerDetails): void {
        const newFormGroup = this.createFormGroup(partnerDetails);
        Object.keys(newFormGroup.controls).forEach((key) => formGroup.addControl(key, newFormGroup.controls[key]));
    }
}
